import { render, staticRenderFns } from "./FieldTypeEmail.vue?vue&type=template&id=85a2c998&"
import script from "./FieldTypeEmail.vue?vue&type=script&lang=ts&"
export * from "./FieldTypeEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports